import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
import ServicesPricingPackages from "@/components/ServicesPricingPackages.vue";
import ServicesPricingFAQs from "@/components/ServicesPricingFAQs.vue";
import FreelancingProfiles from "@/components/FreelancingProfiles.vue";
let Home = class Home extends Vue {
};
Home = __decorate([
    Options({
        components: {
            ServicesPricingPackages,
            ServicesPricingFAQs,
            FreelancingProfiles
        },
        data() {
            return {};
        },
        created: () => {
            console.log(" home created ");
        },
        mounted() {
            console.log(" home mounted ");
        },
        computed: {
            site_data() {
                return this.$store.state.site_data;
            },
        },
    })
], Home);
export default Home;
